import { UserDataProcessingInterface } from '~/models/interfaces/services/Customers'

const initialState: UserDataProcessingInterface = {
  idEntryAutomation: undefined,
}

export default initialState
